import { render, staticRenderFns } from "./BuyExtraMinute.vue?vue&type=template&id=ac2e80a6&scoped=true&"
import script from "./BuyExtraMinute.vue?vue&type=script&lang=js&"
export * from "./BuyExtraMinute.vue?vue&type=script&lang=js&"
import style0 from "./BuyExtraMinute.vue?vue&type=style&index=0&id=ac2e80a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2e80a6",
  null
  
)

export default component.exports